import React from 'react'
import logo from 'assets/svgs/applogo_light.svg';
import './LoadingPage.css';
import useTranslate from "../modules/local/useTranslate";

import {Skeleton, Spin} from "antd";

export const LoadingSpin = ({visible, text = "loading"}) => {
    if (!visible) return null;

    return (
        <div style={overlayStyle}>
            <Spin spinning tip={text}>
                <div style={{width: 200, height: 80}}/>
            </Spin>
        </div>
    );
}

const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(255,255,255,0.6)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

export const LoadingCircle = React.memo(({style = {}, className = "", logoSrc = logo}) => {
    const t = useTranslate()
    return (
        <div className="loading-container flex flex-col flex-center gap-2">
            <svg className="spinner-loading-circle" viewBox="25 25 50 50">
                <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="4"/>
            </svg>
            <div className="loading-text">
                <span>{t('Loading')}</span>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
            </div>
        </div>
    )
})


export const LoadingSkeleton = React.memo(({ nLoop = 2 }) => {
    return (
        <div className="mt-16 p-6 space-y-6">
            {Array.from({ length: nLoop }).map((_, i) => (
                <div
                    key={i}
                    className="mb-6 last:mb-0 pb-6 border-b border-gray-100 last:border-0">
                    <Skeleton loading={true} active />
                </div>
            ))}
        </div>
    );
});

export const LoadingSkeletonContent = React.memo(({}) => {
    return (
        <div className="mb-6 m-3 last:mb-0 pb-6 border-b border-gray-100 last:border-0">
            <Skeleton loading={true} active>

            </Skeleton>
        </div>
    )
})

const LoadingPage = ({style = {}, className = "", logoSrc = logo}) => {
    const t = useTranslate()
    return (
        <div className="loading-container flex flex-col items-center justify-center">
            <div style={style} className={className}>
                <img
                    width={128}
                    height={128}
                    src={logoSrc}
                    fetchpriority="high"
                    alt="Loading..."
                    className="pulse-logo"/>
            </div>
            <div className="loading-text">
                <span>{t('Loading')}</span>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
                <div className="dot-loading">.</div>
            </div>
        </div>
    )
}

export default React.memo(LoadingPage)
